import React from 'react'
import SbcCommon from '../../../toolkit/SbcCommon';
import SbcWrapper from '../../../toolkit/SbcWrapper';

export default function TextFieldConfig({
    data,
    handleIptChange,
    handleMultiIptChange,
    handleSwitchChange,
    handleSelectChange
}) {
    return (
        <SbcWrapper>
            <SbcCommon
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
            />
        </SbcWrapper>
    )
}
